import "core-js/modules/es6.function.name";
import { MDXRenderer } from 'gatsby-plugin-mdx';
import React from 'react';
import ComponentImport from './ComponentImport';
import Example from './Example';
import LinkedHeading from './LinkedHeading';
import Heading from './OutlineHeading';
import PageLayout from './PageLayout';
var Props;

if (process.env.DOCPOC_PROPS_LAYOUT === 'list') {
  Props = require('./PropsList').default;
} else {
  Props = require('./PropsTable').default;
}

function ComponentPage(_ref) {
  var data = _ref.data;
  var _data$docpocalypse = data.docpocalypse,
      description = _data$docpocalypse.description,
      importName = _data$docpocalypse.importName,
      name = _data$docpocalypse.name,
      example = _data$docpocalypse.example;
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    h: 1,
    id: name + "-page",
    title: name
  }, name)), /*#__PURE__*/React.createElement(Example, {
    example: example,
    name: name
  }), /*#__PURE__*/React.createElement(LinkedHeading, {
    h: 2,
    id: name + "-api"
  }, "API"), /*#__PURE__*/React.createElement("div", null, importName && /*#__PURE__*/React.createElement(ComponentImport, {
    importName: importName,
    docNode: data.docpocalypse
  })), (description === null || description === void 0 ? void 0 : description.mdx) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MDXRenderer, {
    scope: {
      React: React
    }
  }, description.mdx.body)), /*#__PURE__*/React.createElement(Props, {
    metadata: data.docpocalypse
  }));
}

export default ComponentPage;